import { useAssets } from '@/api/equipment/assets/getAssets';
import { useGenerators } from '@/api/equipment/generators/getGenerators';
import { useVehicles } from '@/api/equipment/vehicles/getVehicles';
import { ModelID } from '@/types';

interface UseMaintanablesOptions {
  activeLocationId: ModelID;
}

export const useMaintainables = ({ activeLocationId }: UseMaintanablesOptions) => {
  const { data: assets } = useAssets({ location: activeLocationId, search: { active: true } });
  const { data: vehicles } = useVehicles({
    location: activeLocationId,
    search: { is_active: true },
  });
  const { data: generators } = useGenerators({
    location: activeLocationId,
    search: { is_active: true },
  });

  const equipmentOptions = [
    ...(assets ?? []).map((asset) => ({
      value: `asset:${asset.id}`,
      label: asset.name ?? 'Unnamed Asset',
    })),
    ...(vehicles ?? []).map((vehicle) => ({
      value: `vehicle:${vehicle.id}`,
      label: vehicle.name ?? 'Unnamed Vehicle',
    })),
    ...(generators ?? []).map((generator) => ({
      value: `generator:${generator.id}`,
      label:
        `${generator.name} on ${generator.attached_equipment?.name ?? 'Unattached'}` ??
        'Unnamed Generator',
    })),
  ];

  return {
    equipmentOptions,
    assets,
    vehicles,
    generators,
  };
};
